import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const steps = [
  {
    number: "01",
    title: "Connect Your AI Systems",
    description: "Seamless integration with existing healthcare IT infrastructure and EMR systems. Works with TensorFlow and PyTorch."
  },
  {
    number: "02",
    title: "Security Assessment",
    description: "Healthcare security assessment and needs analysis with 30-day pilot delivering measurable results in clinical environments."
  },
  {
    number: "03",
    title: "Deploy Protection",
    description: "White-glove onboarding and training for clinical teams with flexible deployment options: cloud, on-premise, or hybrid."
  },
  {
    number: "04",
    title: "Real-Time Monitoring",
    description: "Continuous threat detection with proactive risk prevention. Comprehensive audit trails ready for FDA and HIPAA compliance."
  }
];

export default function HowItWorksSection() {
  return (
    <section id="integrations" className="py-24 lg:py-32 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <p className="text-[#1e3a5f] text-sm font-medium tracking-wider uppercase mb-4">How It Works</p>
          <h2 className="text-4xl md:text-5xl font-light text-slate-900 mb-6">
            Get Started in 4 Simple Steps
          </h2>
        </motion.div>
        
        <div className="relative">
          {/* Connection line */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-slate-300 to-transparent" />
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <motion.div
                key={step.number}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.15 }}
                className="relative"
              >
                <div className="text-center">
                  <div className="relative inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#1e3a5f] text-white text-xl font-semibold mb-6 z-10">
                    {step.number}
                  </div>
                  
                  {index < steps.length - 1 && (
                    <ArrowRight className="hidden lg:block absolute top-6 -right-4 w-8 h-8 text-slate-300" />
                  )}
                  
                  <h3 className="text-xl font-medium text-slate-900 mb-3">{step.title}</h3>
                  <p className="text-slate-600">{step.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}